import styled from "styled-components/macro";

export const RouteFallback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;
